import { Link, Navigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { getClientByCode, lookupClientAccess, portalPathForClient } from "../../js/api/clientAccess";

export default function ClientCodeRedirect() {
  const { clientCode } = useParams();
  const lookup = lookupClientAccess({ code: clientCode });
  if (lookup.ok) {
    return <Navigate to={portalPathForClient(lookup.client)} replace />;
  }
  const exists = getClientByCode(clientCode);
  return (
    <AppLayout variant="public">
      <article className="card account-card">
        <h1>Portal unavailable</h1>
        <p>{lookup.error || "That Client ID was not found."}</p>
        {exists ? <p className="muted">The office still has this file. Please contact your advisor.</p> : null}
        <Link to="/">Return home</Link>
      </article>
    </AppLayout>
  );
}
